import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorShowCache } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.adbDistrict;

// get list district by province id
export const getListDistrict = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

// create District
export const createDistrict = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const updateDistrict = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const removeDistrict = (id, callback) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getCacheDistrict = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

// deploy cache
export const deployCacheDistrict = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      Toast("success", "Thành công");
      callback(response);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
